import React from 'react'
import styled from '@emotion/styled'

import { breakpoints } from '../../constants'

import DealerInfo from './DealerInfo'
import { FlexDiv } from '../generic/Basics'
import { fontWeightBold, fontSize3XSmall } from '../../constants/principles'

const KbbIcoSvg = __PATH_PREFIX__ + '/Landing/KBBICO-Logo-rgb.svg'
const KbbValuesSvg = __PATH_PREFIX__ + '/Landing/KBBValues-Logo.svg'
const sell2KbbH1MainText = 'Sell Your Car From Home.'
const sell2KbbH1SubText = "We'll Handle the Pick Up."
const sell2KbbV2H1MainText = 'Sell Your Car to Kelley Blue Book'
const sell2KbbV2H1SubText = 'with Free Pick Up'
const sell2KbbH4Text = 'Get a quick, easy, no-obligation Kelley Blue Book® Instant Cash Offer good for 7 days. Plus get the convenience of free at-home pick up.'
const sell2KbbV2H4Text = 'Tell us about your car, choose the time & place and we take care of the rest.'

export default ({ isAssigned, isCombined, dealerName, dealerPhone, isUIOffForDR, dealerIsDirectToKBB, dealerIsDirectToKBBv2, offerCode, heading }) => (
  <StyledFlexDiv>
    <StyledImgDiv isCombined={isCombined}>
      <StyledImg itemProp="image" src={KbbIcoSvg} alt="KBB.com Instant Cash Offer" />
      {isCombined && <StyledImg itemProp="image" src={KbbValuesSvg} alt="KBB.com Instant Cash Offer" />}
    </StyledImgDiv>
    {!isUIOffForDR &&
      offerCode !== 'wc' &&
      offerCode !== 'tc' &&
      (dealerIsDirectToKBB || dealerIsDirectToKBBv2 ? (
        <>
          <StyledH1 directToKBB={dealerIsDirectToKBB} directToKBBv2={dealerIsDirectToKBBv2}>
            {dealerIsDirectToKBB ? sell2KbbH1MainText : sell2KbbV2H1MainText}
            <br />
            {dealerIsDirectToKBB ? sell2KbbH1SubText : sell2KbbV2H1SubText}
          </StyledH1>
          <StyledH4 directToKBBv2={dealerIsDirectToKBBv2}>{dealerIsDirectToKBB ? sell2KbbH4Text : sell2KbbV2H4Text}</StyledH4>
        </>
      ) : (
        <>
          <StyledH1 directToKBB={dealerIsDirectToKBB}>{heading}</StyledH1>
          {isAssigned && <DealerInfo name={dealerName} phone={dealerPhone} />}
        </>
      ))}
  </StyledFlexDiv>
)

const StyledImgDiv = styled.div`
  width: ${p => (p.isCombined ? 320 : 160)}px;
  height: 60px;
  display: flex;
  justify-content: space-between;
`
const StyledImg = styled.img`
  width: 160px;
  height: 58px;
`
const StyledFlexDiv = styled(FlexDiv)`
  width: 100%;
  max-width: 1024px;
`
//font on large viewports is 56, font on small is 34 (neither in Orion)
const StyledH1 = styled.h1`
  font-size: ${p => (p.directToKBB ? 28 : 34)}px;
  font-weight: ${fontWeightBold};
  text-align: center;
  line-height: 35px;
  margin: 8px;
  margin-bottom: ${p => (p.directToKBB ? 12 : 25)}px;
  padding: 0px 8px;
  width: 100%;
  white-space: pre-line;
  @media (min-width: ${breakpoints.lg}px) {
    font-size: 56px;
    font-weight: 800;
    line-height: 60px;
    margin: 16px;
    margin-bottom: ${p => (p.directToKBB ? 18 : 47)}px;
    padding: 0px 18px;
    width: ${p => (p.directToKBB ? 75 : p.directToKBBv2 ? 100 : 60)}%;
  }
`

const StyledH4 = styled.h4`
  font-size: ${fontSize3XSmall};
  font-weight: normal;
  text-align: center;
  line-height: 18px;
  margin: 0px;
  margin-bottom: 25px;
  width: 320px;
  @media (min-width: ${breakpoints.lg}px) {
    font-size: 18px;
    line-height: 24px;
    width: ${p => (p.directToKBBv2 ? 75 : 65)}%;
  }
`
